import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

import { useDashboardShareActions } from './useDashboardShareActions';
import { useSharePetitionModalContext } from './useSharePetitionModal';

export function useTriggerSharePetitionModal(): () => Promise<void> {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const actions = useDashboardShareActions();

	const openSharePetitionModal = useSharePetitionModalContext();
	const triggerShareModal = useCallback(async () => {
		return openSharePetitionModal({ actions, petitionId: petition.id }).waitForResult();
	}, [actions, openSharePetitionModal, petition.id]);

	return triggerShareModal;
}
